import authConfig from './authConfig'
import { Auth0Client } from '@auth0/auth0-spa-js'
import { httpGet } from '../services/http'

const auth0 = new Auth0Client({
  domain: authConfig.domain,
  client_id: authConfig.clientID,
  redirect_uri: window.location.origin,
  audience: authConfig.audience,
  scope: authConfig.scope,
  cacheLocation: 'localstorage',
  //useRefreshTokens: true,
})

export default {
  // called when the user attempts to log in
  login: () => auth0.loginWithPopup(),
  // called when the user clicks on the logout button
  logout: () => {
    return auth0.isAuthenticated().then(async function (isAuthenticated) {
      if (isAuthenticated) {
        // need to check for this as react-admin calls logout in case checkAuth failed
        return auth0.logout({ returnTo: window.location.origin, localOnly: authConfig.localLogoutOnly })
      }
      return Promise.resolve()
    })
  },
  // called when the API returns an error
  checkError: ({ status }) => {
    if (status === 401 || status === 403) {
      return Promise.reject()
    }
    return Promise.resolve()
  },
  // called when the user navigates to a new location, to check for authentication
  checkAuth: () => {
    return auth0.isAuthenticated().then(function (isAuthenticated) {
      if (isAuthenticated) {
        return Promise.resolve()
      }
      return Promise.reject()
    })
  },

  getToken: () => {
    return auth0.getTokenSilently()
  },

  getRoles: () => {
    return auth0.getUser().then((t) => {
      if (t && Array.isArray(t[process.env.REACT_APP_AUTH0_CUSTOM_CLAIM_NS + '/roles'])) {
        return t[process.env.REACT_APP_AUTH0_CUSTOM_CLAIM_NS + '/roles']
      }
    })
  },

  getAdminApiKey: async () => {
    const headers = { Authorization: `Bearer ${await auth0.getTokenSilently()}` }
    const { data: response } = await httpGet({ url: `${process.env.REACT_APP_USER_API}/token`, config: { headers } })
    return response
  },

  getPermissions: () => {
    return auth0.getUser().then((t) => {
      const roles = t[process.env.REACT_APP_AUTH0_CUSTOM_CLAIM_NS + '/roles']
      const isRunner = roles?.some((role) => role.startsWith('runner'))
      const isSales = roles?.some((role) => role.startsWith('sales'))
      const email = t.email

      let permissions = {
        inspection: {
          canCreate: false,
          canEdit: false,
          canDelete: false,
          canRead: false,
        },
        property: {
          canCreate: false,
          canEdit: false,
        },
        landlord: {
          canCreate: false,
          canEdit: false,
        },
        canGoToMyPhoner: false,
        canGoToPipedrive: false,
      }
      if (isRunner) {
        permissions = {
          ...permissions,
          inspection: {
            canCreate: false,
            canEdit: (inspection) => email === inspection.created_by,
            canDelete: (inspection) => email === inspection.created_by,
          },
        }
      }
      if (isSales) {
        permissions = {
          ...permissions,
          canGoToMyPhoner: true,
          canGoToPipedrive: true,
          property: { canCreate: true, canEdit: true },
          landlord: { canCreate: true, canEdit: true },
          inspection: {
            canCreate: true,
            canEdit: (inspection) => email === inspection.created_by,
            canDelete: (inspection) => email === inspection.created_by,
          },
        }
      }
      return permissions
    })
  },

  getIdentity: () => {
    return auth0.getUser().then((t) => {
      if (t) {
        const roles = t[process.env.REACT_APP_AUTH0_CUSTOM_CLAIM_NS + '/roles']
        const isRunner = roles?.some((role) => role.startsWith('runner'))
        const isSales = roles?.some((role) => role.startsWith('sales'))
        return { fullName: t.email, isRunner, isSales, email: t.email }
      }
    })
  },
}
